<div *ngIf="current != null" [style]="current.cssStyles">
    <img [src]="current.url" (click)="onClick()" alt="" />
</div>